function normalizeClarificationOptionsUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = String(result.type || '').toLowerCase() === 'clarification-options'
    ? result
    : result.clarificationUi || result.clarificationOptionsUi || result.clarificationOptions || result.ui || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'clarification-options') return null

  var options = Array.isArray(ui.options) ? ui.options.map(normalizeClarificationOption).filter(Boolean) : []
  if (!options.length) return null

  return {
    type: 'clarification-options',
    title: String(ui.title || ''),
    selectionMode: ui.selectionMode === 'multiple' ? 'multiple' : 'single',
    options: options
  }
}

function normalizeClarificationOption(option) {
  if (!option || typeof option !== 'object') return null
  var label = String(option.label || '').trim()
  if (!label) return null
  var action = normalizeClarificationAction(option.action)
  if (!action) return null

  return {
    id: String(option.id || label),
    label: label,
    description: option.description ? String(option.description) : '',
    context: Array.isArray(option.context)
      ? option.context.map(function (value) { return String(value || '').trim() }).filter(Boolean)
      : [],
    value: option.value && typeof option.value === 'object' ? option.value : null,
    action: action
  }
}

function normalizeClarificationAction(action) {
  if (!action || typeof action !== 'object') return null
  var type = String(action.type || '').toLowerCase()
  if (type === 'goto_step') {
    var stepKey = String(action.stepKey || '').trim()
    if (!stepKey) return null
    return {
      type: 'goto_step',
      stepKey: stepKey,
      requestContext: action.requestContext && typeof action.requestContext === 'object' ? action.requestContext : {}
    }
  }
  if (type === 'send_message') {
    var message = String(action.message || '').trim()
    if (!message) return null
    return {
      type: 'send_message',
      message: message,
      requestContext: action.requestContext && typeof action.requestContext === 'object' ? action.requestContext : {}
    }
  }
  return null
}

function renderClarificationOptionsUi(clarificationUi) {
  var title = clarificationUi.title
    ? '<div class="wc-clarification-title">' + escapeHtml(clarificationUi.title) + '</div>'
    : ''
  var options = clarificationUi.options.map(function (option, index) {
    var context = option.context.length
      ? '<span class="wc-clarification-option-context">' + escapeHtml(option.context.join(' - ')) + '</span>'
      : ''
    return (
      '<button type="button" class="wc-clarification-option" data-clarification-option-index="' + String(index) + '">' +
        '<span class="wc-clarification-option-label">' + escapeHtml(option.label) + '</span>' +
        context +
        (option.description ? '<span class="wc-clarification-option-description">' + escapeHtml(option.description) + '</span>' : '') +
      '</button>'
    )
  }).join('')

  return (
    '<div class="wc-clarification-ui">' +
      title +
      '<div class="wc-clarification-option-list">' + options + '</div>' +
    '</div>'
  )
}

function bindClarificationOptionsUi(el, clarificationUi, handlers) {
  if (!el || !clarificationUi || !handlers || typeof handlers.onSelect !== 'function') return
  Array.prototype.slice.call(el.querySelectorAll('[data-clarification-option-index]')).forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return
      var index = Number(button.getAttribute('data-clarification-option-index') || -1)
      var option = clarificationUi.options[index]
      if (!option) return
      button.disabled = true
      handlers.onSelect(option)
    })
  })
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export { bindClarificationOptionsUi, normalizeClarificationOptionsUi, renderClarificationOptionsUi }
